import { IEventBus, SystemEventHandler } from '@/contracts/core/event/interface/IEventBus'
import { EnumSystemEvent } from '@/contracts/core/event/enum/EnumSystemEvent'

export class EventBusV1 implements IEventBus {
  private handlers: Map<EnumSystemEvent, Set<SystemEventHandler>> = new Map()

  on(event: EnumSystemEvent, handler: SystemEventHandler): void {
    this._handlersOf(event).add(handler)
  }

  off(event: EnumSystemEvent, handler: SystemEventHandler): void {
    this._handlersOf(event).delete(handler)
  }

  emit(event: EnumSystemEvent): void {
    // копия: обработчик может отписаться во время вызова
    Array.from(this._handlersOf(event)).forEach((handler) => handler())
  }

  _handlersOf(event: EnumSystemEvent): Set<SystemEventHandler> {
    let handlers = this.handlers.get(event)
    if (!handlers) {
      handlers = new Set()
      this.handlers.set(event, handlers)
    }

    return handlers
  }
}
